// extracted by mini-css-extract-plugin
module.exports = {"btn":"c_f"};